module.exports = __webpack_public_path__ + "static/media/g-4-e.b914cb55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-4-e.jpg
// module id = 1140
// module chunks = 33